export function templateAxisKey(label: string, lesson: number | null | undefined, index: number): string {
  const clock = clockRangeKey(label) ?? label
  return lesson != null ? `${clock}#${lesson}` : `${clock}#row${index}`
}

export function templateAxisLesson(key: string): number | null {
  const suffix = key.split('#')[1]
  if (!suffix || !/^\d+$/.test(suffix)) return null
  return Number(suffix)
}

export function clockRangeKey(label: string | null | undefined): string | null {
  const match = (label || '').match(/(\d{1,2}):(\d{2})\s*[-–]\s*(\d{1,2}):(\d{2})/)
  if (!match?.[1] || !match[2] || !match[3] || !match[4]) return null
  return `${match[1].padStart(2, '0')}:${match[2]}–${match[3].padStart(2, '0')}:${match[4]}`
}

export function parseTimeToMinutes(timeStr: string | null | undefined): number {
  if (!timeStr) return 0
  const match = timeStr.match(/(\d{1,2}):(\d{2})/)
  if (!match || !match[1] || !match[2]) return 0
  return parseInt(match[1], 10) * 60 + parseInt(match[2], 10)
}

export function normalizeTimeSlot(timeStr: string | null | undefined): string | null {
  if (!timeStr) return null

  // Try standard format first: "8:30-9:15"
  let match = timeStr.match(/(\d{1,2}):(\d{2})\s*[-–]\s*(\d{1,2}):(\d{2})/)
  if (match && match[1] && match[2] && match[3] && match[4]) {
    const startH = parseInt(match[1], 10)
    const startM = match[2]
    const endH = parseInt(match[3], 10)
    const endM = match[4]
    return `${startH}:${startM}-${endH}:${endM}`
  }

  // Try malformed format: "15:35-1620" (missing colon in end time)
  match = timeStr.match(/(\d{1,2}):(\d{2})\s*[-–]\s*(\d{2})(\d{2})/)
  if (match && match[1] && match[2] && match[3] && match[4]) {
    const startH = parseInt(match[1], 10)
    const startM = match[2]
    const endH = parseInt(match[3], 10)
    const endM = match[4]
    return `${startH}:${startM}-${endH}:${endM}`
  }

  return timeStr
}
